import * as React from 'react';

function FlexAutosizeFixer({ children }: { children?: React.ReactNode }) {
  return <div style={{ position: 'absolute', width: '100%', height: '100%' }}>{children}</div>;
}

export default FlexAutosizeFixer;
